import React, { ReactElement } from 'react';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { useStyles } from './styles';
import { SingleTemplateErrorProps } from './types';

import BrowserIcon from 'assets/icons/browser.svg?react';
import { useIntl } from 'react-intl';
import useIsMobile from 'hooks/useIsMobile';

function SingleTemplateError(
  props: SingleTemplateErrorProps
): ReactElement {
  const { error } = props;
  const isMobile = useIsMobile();
  const classes = useStyles({ isMobile });
  const intl = useIntl();

  return (
    <div className={classes.wrapper}>
      <BrowserIcon />
      <p className={classes.errorText}>
        {formatTranslation(intl, unsafeTranslationKey(error.templateErrorType) )}
      </p>
      <span className={classes.helperText}>
        {formatTranslation(intl, unsafeTranslationKey(error.helperText) )}
      </span>
    </div>
  );
}

export const MemoSingleTemplateError = React.memo(SingleTemplateError);
